import jwt from 'jsonwebtoken';
import React, {Component} from 'react';
import {HashRouter, Redirect, Route, Switch} from 'react-router-dom';
import Sidebar from 'react-sidebar';
import styled from 'styled-components';
import {Centered1000} from './components/container/CenteredContainer';
import SidebarContent, {sidebarStyles} from './components/SidebarContent';
import {AUTH_TOKEN_STORAGE_KEY} from './constants/storageConstants';
import {
  ROLE_ADMIN,
  ROLE_EMPLOYEE,
  ROLE_SUPER_ADMIN,
} from './constants/userConstants';
import ArtCollections from './containers/ArtCollections';
import LoginPage from './containers/LoginPage';
import OfferExport from './containers/OfferExport';
import UserEdit from './containers/UserEdit';
import UserLogs from './containers/UserLogs';
import UserNew from './containers/UserNew';
import UsersPage from './containers/UsersPage';
import constants from './parameters/constants';
const logo = require('./img/hauser-wirth-logo.png');

const SidebarToggle = styled.div`
  position: absolute;
  left: 20px;
  top: 20px;
  width: 40px;
  height: 40px;
  background: ${constants.primaryColor};
  font-size: 25px;
  line-height: 40px;
  text-align: center;
  color: ${constants.complementaryColor};
  cursor: pointer;
  z-index: 500;
`;

const LogoWrapper = styled.div`
  padding: 60px 40px;
  background-color: ${constants.primaryColor}
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

class AuthRoute extends Component {
  shouldComponentUpdate({user, path, computedMatch: {url}}) {
    let oldUser = this.props.user;
    let newUserId = user && user._id;
    let oldUserId = oldUser && oldUser._id;
    return newUserId !== oldUserId || url !== this.props.computedMatch.url;
  }

  render() {
    let {component: Component, user, role, ...rest} = this.props;
    return (
      <Route
        {...rest}
        render={props => {
          let isAllowed = false;
          if (!role && user) {
            isAllowed = true;
          } else if (user) {
            if (user.role === ROLE_ADMIN || user.role === ROLE_SUPER_ADMIN) {
              isAllowed = true;
            } else {
              isAllowed = user.role === role;
            }
          }
          return isAllowed ? (
            <Component {...props} user={user} />
          ) : (
            <Redirect
              to={{pathname: '/login', state: {from: props.location}}}
            />
          );
        }}
      />
    );
  }
}

function getUser() {
  let user;
  let token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  if (token) {
    token = token.replace('Bearer JWT ', '');
    user = jwt.decode(token);
    user.token = 'Bearer JWT ' + token;
  }
  return user;
}

export default class Navigation extends Component {
  constructor() {
    super();
    this.state = {sidebarOpen: false};
  }

  onSetSidebarOpen = open => {
    this.setState({sidebarOpen: open});
  };

  render() {
    let user = getUser();
    return (
      <HashRouter>
        <Switch>
          <Route
            exact
            path='/login'
            render={props =>
              user ? (
                <Redirect
                  to={{pathname: '/users', state: {from: props.location}}}
                />
              ) : (
                <LoginPage
                  {...props}
                  rerender={() => this.setState({update: Date.now()})}
                />
              )
            }
          />
          <Sidebar
            sidebar={
              <div>
                <LogoWrapper>
                  <img
                    src={logo}
                    alt='Hauser & Wirth Logo'
                    width='100%'
                    height='100%'
                  />
                </LogoWrapper>
                <div onClick={() => this.setState({sidebarOpen: false})}>
                  <SidebarContent user={user || {}} />
                </div>
              </div>
            }
            open={this.state.sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
            styles={sidebarStyles}>
            <SidebarToggle onClick={() => this.setState({sidebarOpen: true})}>
              ≡
            </SidebarToggle>
            <Centered1000>
              <Switch>
                <AuthRoute
                  user={user}
                  role={ROLE_EMPLOYEE}
                  exact
                  path='/users'
                  component={UsersPage}
                />
                <AuthRoute
                  user={user}
                  role={ROLE_EMPLOYEE}
                  path='/users/:role'
                  component={UsersPage}
                />
                <AuthRoute
                  user={user}
                  role={ROLE_EMPLOYEE}
                  exact
                  path='/new/user'
                  component={UserNew}
                />
                <AuthRoute
                  user={user}
                  role={ROLE_EMPLOYEE}
                  path='/user/:id'
                  component={UserEdit}
                />
                <AuthRoute
                  user={user}
                  role={ROLE_EMPLOYEE}
                  path='/logs/:id'
                  component={UserLogs}
                />
                <AuthRoute
                  user={user}
                  role={ROLE_EMPLOYEE}
                  path='/art-collections/:userId'
                  component={ArtCollections}
                />
                <AuthRoute
                  user={user}
                  role={ROLE_EMPLOYEE}
                  path='/offer-export'
                  component={OfferExport}
                />
                <Redirect to='/users' />
              </Switch>
            </Centered1000>
          </Sidebar>
        </Switch>
      </HashRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Navigation.js